import { render, staticRenderFns } from "./menu-child-layout.vue?vue&type=template&id=659b1829"
import script from "./menu-child-layout.vue?vue&type=script&lang=js"
export * from "./menu-child-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports